import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function WLWHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-2256">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/pJQxuQV35gtGjaegsc1gvx/weight-loss-for-women-1.jpg)'
    }} data-id="element-2257" />
      <div className="absolute inset-0 bg-black/50" data-id="element-2258" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-2259">
        <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-2260">
          <div className="mb-6" data-id="element-2261">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-2262">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-2263">
                Treatments
              </a>{' '}
              / Body
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-2264">
            Be DARING
          </span>

          <h1 className="text-[32px] sm:text-5xl lg:text-[56px] uppercase text-white tracking-tight mb-2 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-2265">
            WEIGHT LOSS FOR WOMEN
          </h1>

          <p className="font-serif italic text-white/80 text-xl lg:text-2xl mb-8 mt-3" data-id="element-2266">
            in a nutshell
          </p>

          <div className="space-y-6" data-id="element-2267">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-2268">
              <em data-id="element-2269">
                "Ladies, imagine opening your closet and feeling excited to wear
                anything you want—those clothes you've been saving because
                they're too tight, how happy would you be if it all fits
                perfectly?"
              </em>{' '}
              says Dr. Fiona Frie.
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-2270">
              <em data-id="element-2271">
                "One of the most frustrating things about aging as a woman is
                how hard it can be to maintain an ideal weight. You're eating
                healthy and you're working out consistently, but you aren't
                seeing results. Or, you're in the perimenopausal phase of life
                and you're noticing extra pounds, a bloated belly or an
                expanding waistband,"
              </em>{' '}
              explains Dr. Fiona.{' '}
              <em data-id="element-2272">
                "It can be so confusing and upsetting when your body seems to
                have a mind of its own despite all of your efforts."
              </em>
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-2273">
              At Be CLINICAL, we're here to help women navigate weight loss at
              any age. Say goodbye to frustration and hello to results!
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-2274">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}